import React from "react";
import { Heading, Flex, Box, Container, Link, Text, Tooltip } from "rebass";
import styled from "styled-components";
import omit from "lodash.omit";

import { metaDataProps } from "../pages/index";
import facebook from "../img/facebook-icon.svg";
import messenger from "../img/facebook-messenger.svg";
import slack from "../img/slack.svg";
import salesforce from "../img/salesforce.svg";
import shopify from "../img/shopify.svg";
import zapier from "../img/zapier.svg";
import serviceBg1 from "../img/services/service-bg-1.svg";
import serviceBg2 from "../img/services/service-bg-2.svg";
import serviceBg3 from "../img/services/service-bg-3.svg";
import serviceBg4 from "../img/services/service-bg-4.svg";
import serviceBg5 from "../img/services/service-bg-5.svg";
import serviceBg6 from "../img/services/service-bg-6.svg";

type Props = {
  siteMetadata: metaDataProps
};

const propsToOmit = ["siteMetadata"];
const px = [4, 4, 5, 4];
const mb = [4, 4, 0];

const Proof = (props: Props) => (
  <WrapBox {...omit(props, propsToOmit)}>
    <Container>
      <Heading
        center
        mb={[5, 4, 5]}
        f={[3, 3, "26px"]}
        px={[2]}
        color="support2"
        className="font-light"
      >
        Works in conjunction with&hellip;
      </Heading>

      <Flex wrap align="center" justify="center" mb={[4, 4, 4, 5]}>
        <Box1 flex="1 1 auto" className="text-center" px={px} mb={mb}>
          <Customer src={facebook} alt="facebook logo" />
        </Box1>

        <Box2 flex="1 1 auto" className="text-center" px={px} mb={mb}>
          <Customer src={messenger} alt="facebook messenger logo" />
        </Box2>

        <Box3 flex="1 1 auto" className="text-center" px={px} mb={mb}>
          <Customer src={shopify} alt="shopify logo" />
        </Box3>

        <Box4 flex="1 1 auto" className="text-center" px={px} mb={mb}>
          <Tooltip text="Enterprise Plan">
            <Customer src={slack} alt="slack logo" />
          </Tooltip>
        </Box4>

        <Box5 flex="1 1 auto" className="text-center" px={px} mb={mb}>
          <Tooltip text="Enterprise Plan">
            <Customer src={zapier} alt="zapier logo" />
          </Tooltip>
        </Box5>

        <Box6 flex="1 1 auto" className="text-center" px={px} mb={mb}>
          <Tooltip text="Enterprise Plan">
            <Customer src={salesforce} alt="salesforce logo" />
          </Tooltip>
        </Box6>
      </Flex>

      <Text center className="font-light">
        And many more!&nbsp;
        <StyledLink href={props.siteMetadata.appUrl}>Ready to try?</StyledLink>
      </Text>
    </Container>
  </WrapBox>
);

export default Proof;

// Styled Components
const Customer = styled.img`
  height: auto;
  max-width: 80px;
  opacity: 0.8;
  width: 100%;
`;

const StyledLink = styled(Link)`
  color: #8d9db9;
  text-decoration: none;
  transition: all 300ms ease-in-out;

  &:visited {
    color: #8d9db9;
  }

  &:hover {
    color: ${p => p.theme.colors.primary};
  }
`;

const StyledBox = styled(Box)`
  background-size: 100%;
`;

const Box1 = StyledBox.extend`
  background: url(${serviceBg1}) no-repeat bottom left;
`;

const Box2 = StyledBox.extend`
  background: url(${serviceBg2}) no-repeat bottom left;
`;

const Box3 = StyledBox.extend`
  background: url(${serviceBg3}) no-repeat bottom left;
`;

const Box4 = StyledBox.extend`
  background: url(${serviceBg4}) no-repeat bottom left;
`;

const Box5 = StyledBox.extend`
  background: url(${serviceBg5}) no-repeat bottom left;
`;
const Box6 = StyledBox.extend`
  background: url(${serviceBg6}) no-repeat bottom left;
`;

const WrapBox = styled(Box)`
  position: relative;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./src/components/Proof.jsx